import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { API_BASE } from '@progressio/client-toolkit';
import { Router } from '@angular/router';
import { UserPermissionsResponse } from '../dto/user-permissions.dto';
import { PermissionService } from '../authorization/permission.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionApiService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly apiBase: string = inject(API_BASE);
  private readonly permissionService: PermissionService = inject(PermissionService);
  private readonly router: Router = inject(Router);

  loadUserPermissions(): Observable<UserPermissionsResponse> {
    const url: string = `${this.apiBase}/admin/roles/me/permissions`;

    return this.http
      .get<UserPermissionsResponse>(url, {
        params: { organization: 'default' },
      })
      .pipe(
        tap((response: UserPermissionsResponse) => {
          this.permissionService.setPermissionsFromApi(response);

          if (this.permissionService.isRestricted()) {
            this.router.navigate(['/forbidden']);
          }
        })
      );
  }
}
